import { render } from "./AppAvatar.vue?vue&type=template&id=0d292648&scoped=true&lang=pug"
const script = {}

import "./AppAvatar.vue?vue&type=style&index=0&id=0d292648&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d292648"]])

export default __exports__